<template>
  <div class="loading">
    <div class="progress" v-if="!error">
      <div class="track" :style="{width: `${progress}%`}"></div>
    </div>
    <div class="error" v-else>
      <div>Uh oh! An error occurred while preloading assets.</div>
      <div>Try <a href="/">reloading</a> the page.</div>
    </div>
  </div>
</template>

<script>
const PRELOAD_ASSETS = [
  '/background.jpg',
  '/michaelbates.jpg',
  '/favicon.ico'
]

export default {
  data () {
    return {
      progress: 0,
      error: false
    }
  },
  methods: {
    async ready () {
      this.progress = 0
      try {
        await this.preloadAll()
        this.$emit('complete')
      } catch (e) {
        this.error = true
      }
    },
    preloadAll () {
      return Promise.all(PRELOAD_ASSETS.map(path => this.preloadAsset(path)))
    },
    preloadAsset (path) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        image.onload = () => {
          this.progress += 100 / PRELOAD_ASSETS.length
          resolve()
        }
        image.onerror = () => reject()
        image.src = path
      })
    }
  },
  mounted () {
    this.ready()
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/mixins";

.loading {
  width: 100%;
  height: 100%;
  background-color: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .error {
    color: white;
    font-family: Courier, monospace;
    text-align: center;

    a {
      color: white;
      text-decoration: underline;
    }
  }

  .progress {
    width: 300px;
    height: 8px;
    overflow: hidden;
    margin-top: 200px;
    @include border-radius(10px);

    .track {
      height: 100%;
      background-color: white;
      @include transition(width 0.3s);
    }
  }
}
</style>
